import "aos/dist/aos.css";
import "@/styles/globals.css";
import "@/styles/calendly.css";
import { GoogleAnalytics } from "@next/third-parties/google";
import { SpeedInsights } from "@vercel/speed-insights/next";
import dynamic from "next/dynamic";
import { Montserrat } from "next/font/google";
import { useRouter } from "next/router";
import PlausibleProvider from "next-plausible";
import Nav from "@/components/nav";
import { PageThemeProvider } from "@/components/page-theme-provider";
import BreadcrumbsJsonLd from "@/utils/BreadcrumbsJsonLd";
import CalendlyBookingTracking from "@/components/calendly-booking-tracking";

const Footer = dynamic(() => import("@/components/footer"), {
  loading: () => null,
});
const LogoOnlyNav = dynamic(() => import("@/components/nav/logo-only"));

const montserrat = Montserrat({
  subsets: ["latin"],
  variable: "--font-montserrat",
  display: "swap",
  adjustFontFallback: true,
});

export default function App({ Component, pageProps }) {
  const router = useRouter();
  const pageTheme = Component.serviceTheme;
  const isServicesPage =
    router.pathname === "/services" || router.pathname.startsWith("/services/");
  const isPortalPage = router.pathname === "/ups-portal";
  const isQuestionnairePage = router.pathname === "/web-design-questionnaire";
  const showPortalNav = isPortalPage && pageProps?.isAuthenticated;
  const hideNav =
    isServicesPage ||
    isQuestionnairePage ||
    router.pathname.includes("/studio") ||
    router.pathname.includes("test");
  const hideFooter =
    isServicesPage ||
    isPortalPage ||
    isQuestionnairePage ||
    router.pathname.includes("test");
  const topMarginClass = hideNav
    ? "mt-0"
    : isPortalPage
      ? showPortalNav
        ? "mt-[81px]"
        : "mt-0"
      : "pt-[81px]";

  const appMain = (
    <PageThemeProvider pathname={router.pathname} theme={pageTheme}>
      <main
        className={`relative ${montserrat.variable} ${topMarginClass}`}
      >
        {showPortalNav ? <LogoOnlyNav /> : !isPortalPage && !hideNav && <Nav key={router.pathname} />}
        {!router.pathname.includes("test") && <BreadcrumbsJsonLd />}
        <Component {...pageProps} />

        {!hideFooter && <Footer usesServiceTemplate={!pageProps.reportSlug && Component.usesServiceTemplate} hideCTA={Boolean(pageProps.reportSlug) || router.pathname === '/audit' || router.pathname === '/ups/shopify' || router.pathname === '/[commercialService]/[id]'} />}
      </main>
    </PageThemeProvider>
  );

  return (
    <>
      <PlausibleProvider domain="venturawebdesign.com" enabled>
        <CalendlyBookingTracking />
        {appMain}
      </PlausibleProvider>
      <GoogleAnalytics gaId="G-H5KRCF6VZP" />
      <SpeedInsights />
    </>
  );
}
